<script lang="ts" setup>
	import {useRegionStore} from '@/store/region.store';
	import type {RegionDecorator} from '@/types/region.decorator';
	import {computed} from 'vue';
	import Multiselect from 'vue-multiselect';
	import {useFilters} from '@/store/filter.store';

	const emit = defineEmits(['filters-updated']);

	const regionStore = useRegionStore();

	const filterStore = useFilters();

	const selectedRegion = computed(() => regionStore.getSelectedRegion());

	const regions = computed(() => regionStore.regions);

	const updateRegion = (value: RegionDecorator): void => {
		regionStore.setSelectedRegion(value);
		filterStore.setActivePage(0);

		emit('filters-updated');
	};
</script>

<template>
	<div id="filter-part--country" class="filter-part filter-part--country">
		<h3>{{ $t('site.products.overview.filters.country.title') }}</h3>
		<multiselect
				id="regionSelect"
				:allow-empty="false"
				:close-on-select="true"
				:model-value="selectedRegion"
				:options="regions"
				:show-labels="false"
				label="name"
				track-by="value"
				@update:model-value="updateRegion">
		</multiselect>
	</div>
</template>
